import { cn } from '@/lib/utils';

/**
 * HeroMark — poudarjen logo "kvadrat z žarom" iz mockupa (/design skill).
 * Gradient iz naglasa (--brand → --primary) + mehka senca v barvi naglasa.
 * Uporabljen na prijavni strani in v pozdravnem chatu, da sta usklajena.
 * Ikono poda klicatelj (Scale na prijavi, AssistantIcon v chatu).
 */
export function HeroMark({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'mx-auto flex items-center justify-center rounded-2xl text-brand-foreground',
        'bg-gradient-to-br from-brand to-primary',
        className
      )}
      style={{ boxShadow: '0 14px 36px -8px color-mix(in oklab, var(--brand) 48%, transparent)' }}
    >
      {children}
    </div>
  );
}
